import streamers from '../images/streamers.jpg'

css .photos-page
	min-height:100vh
	d:flex
	fld:column
	.shape-header
		h:300px
				
tag photos-page
	<self.photos-page>
		<shape-header title="Photos" image=streamers>
		<text-block title="Photos">
			"Coming soon..."

		<footer-section>